import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/centos': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M289.6 97.5l31.6 31.7-76.3 76.5v-108.2h44.7zM127.2 129.2l31.6-31.7h44.7v108.2zM168.7 87.6l55.5-55.6 55.5 55.6h-44.7v127.9l-10.8 10.8-10.8-10.8v-127.9h-44.7zM194.9 255.7l-10.8 10.8h-128.6v44.8l-55.5-55.6 55.5-55.6v44.8h128.6zM274.2 235l76.3-76.5 31.6 31.7v44.8h-107.9zM447.5 255.7l-55.5 55.6v-44.8h-127.7l-10.8-10.8 10.8-10.8h127.7v-44.8zM65.4 176.2v-78.7h79.4l-31.6 31.7 90.3 90.5v15.3h-15.3l-90.3-90.5zM382.1 97.5v78.7l-31.6-31.7-90.3 90.5h-15.3v-15.3l90.3-90.5-31.6-31.7h78.5zM203.5 413.9v0.1h-44.7l-31.6-31.7 76.3-76.5v108.1zM65.4 235v-44.8l32.5-31.7 76.3 76.5h-108.8zM382.1 335.2v78.7h-78.5l31.6-31.7-90.3-90.5v-15.3h15.3l90.3 90.5zM382.1 276.4v44.8l-31.6 31.7-76.3-76.5h107.9zM321.2 382.2l-31.6 31.6h-44.7v-108.1zM97.9 352.9l-32.5-31.7v-44.8h108.8zM279.7 423.8l-55.5 55.6-55.5-55.6h44.7v-127.9l10.8-10.8 10.8 10.8v127.9h44.7zM113.2 382.2l31.6 31.7h-79.4v-78.7l32.5 31.7 90.3-90.5h15.3v15.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/centos.js
// module id = 754
// module chunks = 0